import { defineMessages } from 'react-intl';

const messages = defineMessages({
  CustomHref: {
    id: 'label_custom_href',
    defaultMessage: 'Custom Link',
  },
  CustomHrefHelp: {
    id: 'help_custom_href',
    defaultMessage:
      'Use a custom link instead of the default content URL (if the custom link starts with a question mark, it will be appended to the content URL as query parameters).',
  },
});

export const teaserSchemaEnhancer = ({
  schema,
  formData,
  intl,
}: {
  schema: any;
  formData: any;
  intl: any;
}) => {
  schema.properties.href.selectedItemAttrs.push('getRemoteUrl');

  schema.properties.custom_href = {
    title: intl.formatMessage(messages.CustomHref),
    description: intl.formatMessage(messages.CustomHrefHelp),
  };

  if (formData?.overwrite) {
    schema.fieldsets[0].fields.push('custom_href');
  }

  return schema;
};

export const gridTeaserDisableStylingSchema = ({
  schema,
  formData,
  intl,
}: {
  schema: any;
  formData: any;
  intl: any;
}) => {
  schema.fieldsets = schema.fieldsets.filter(
    (item: { id?: string }) => item.id !== 'styling',
  );
  return schema;
};
